var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayinline = function SvgPlayinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.43 193.43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play_inline_svg__designs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 193.43 0 0 193.43 96.71 0 193.43",
    fill: "#c6c6c6"
  }))));
};
export { SvgPlayinline as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTMuNDMgMTkzLjQzIj4KICA8ZyBpZD0iZGVzaWducyI+CiAgICA8cG9seWdvbiBwb2ludHM9IjAgMTkzLjQzIDAgMCAxOTMuNDMgOTYuNzEgMCAxOTMuNDMiIGZpbGw9IiNjNmM2YzYiPjwvcG9seWdvbj4KICA8L2c+Cjwvc3ZnPg==";